import React from 'react';

type SubmitRequestButtonProps = {
  isSubmitting: boolean;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  label?: string;
  submittingLabel?: string;
  'data-testid'?: string;
};

const SubmitRequestButton: React.FC<SubmitRequestButtonProps> = ({
  isSubmitting,
  disabled = false,
  onClick,
  className = '',
  label = 'Submit',
  submittingLabel = 'Submitting…',
  'data-testid': dataTestId = 'submit-button',
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || isSubmitting}
    data-testid={dataTestId}
    aria-busy={isSubmitting}
    className={`${className} disabled:opacity-60 disabled:cursor-not-allowed`}
  >
    {isSubmitting ? (
      <span className="inline-flex items-center justify-center gap-2">
        <span
          className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden
        />
        {submittingLabel}
      </span>
    ) : (
      label
    )}
  </button>
);

export default SubmitRequestButton;
